import { useLocation } from "react-router-dom";
import { parseQueryString } from "../utils/url-query-params";

export function useQueryString() {
  const location = useLocation();
  return parseQueryString(location.search);
}
